import RolesListManager from './RolesListManager'

export default RolesListManager
